import { useTranslation } from 'react-i18next';
import { ActionIcon, Button, CopyButton, Tooltip } from '@mantine/core';
import { IconCheck, IconCopy } from '@tabler/icons-react';

// Единый UX копирования в буфер (как в API-токене): Tooltip «Копировать»/«Скопировано»,
// на успех — зелёная галочка. Иконка — для одного значения, кнопка с текстом — для «скопировать всё».

interface CopyIconButtonProps {
  readonly value: string;
  /** aria-label, напр. «Копировать ИНН». По умолчанию — общий «Копировать». */
  readonly ariaLabel?: string;
}

export function CopyIconButton({ value, ariaLabel }: CopyIconButtonProps) {
  const { t } = useTranslation();
  return (
    <CopyButton value={value} timeout={1500}>
      {({ copied, copy }) => (
        <Tooltip label={copied ? t('common.copied') : t('common.copy')} withArrow>
          <ActionIcon
            variant="subtle"
            size="sm"
            color={copied ? 'lime' : 'gray'}
            onClick={copy}
            aria-label={ariaLabel ?? t('common.copy')}
          >
            {copied ? <IconCheck size={16} /> : <IconCopy size={16} />}
          </ActionIcon>
        </Tooltip>
      )}
    </CopyButton>
  );
}

interface CopyTextButtonProps {
  readonly value: string;
  /** Текст кнопки в обычном состоянии, напр. «Скопировать всё». */
  readonly label: string;
}

export function CopyTextButton({ value, label }: CopyTextButtonProps) {
  const { t } = useTranslation();
  return (
    <CopyButton value={value} timeout={1500}>
      {({ copied, copy }) => (
        <Button
          variant="subtle"
          size="compact-sm"
          color={copied ? 'lime' : undefined}
          leftSection={copied ? <IconCheck size={16} /> : <IconCopy size={16} />}
          onClick={copy}
        >
          {copied ? t('common.copied') : label}
        </Button>
      )}
    </CopyButton>
  );
}
